module.exports = __webpack_public_path__ + "img/bindu_gupta.6f605102.jpg";